import {BaseRequest, post} from './jsonHttp';
import {API_URL} from '@/config';
import authService from '../services/authService';

export const doCreate = async <EntityCreationType, EntityType>(
  path: string, dto: EntityCreationType
): Promise<EntityType> => {
  return post({
    baseUrl: API_URL,
    path,
    body: dto,
    headers: await getHeaders({}),
  });
};

const getHeaders = async (request?: Partial<BaseRequest>): Promise<Record<string, string>> => {
  const {access} = await authService.refreshToken();
  const headers = {...request?.headers};
  if (access) {
    headers['Authorization'] = `Bearer ${access}`;
  }
  return headers;
};